import styles from './FragenUndAntworten.module.scss';
import { useSelector } from 'react-redux';
import { selectIsWarenempfaenger } from '../../store/Navigation.store';
/*
IFrame not resizing
The most common cause of this is not placing the iframeResizer.contentWindow.min.js script inside the iFramed page.
If the other page is on a domain outside your control and you can not add JavaScript to that page, then now is the time to give up all hope
of ever getting the iFrame to size to the content. As it is impossible to work out the size of the contained page, without using JavaScript
on both the parent and child pages.

 */
const FragenUndAntworten = (): JSX.Element => {
    const isWarenempfaenger = useSelector(selectIsWarenempfaenger);
    const url = `https://www.deuka.de/deu-pa/fragen-und-antworten-fuer-${
        isWarenempfaenger ? 'warenempfaenger' : 'debitoren'
    }/?external=true&extended=true`;
    return (
        <>
            <iframe title="Fragen und Antworten" className={styles._frame} src={url} />
        </>
    );
};

export default FragenUndAntworten;
